// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o1Qn","index":"styles_index__KVwAd"};